import { proposalHistoryObsLabelKey } from "src/app/pages/proposals/utils/proposal-history-obs-label.util";
import { scheduleProposalsWindowUnlock } from '../../services/proposals-window.util';
import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { ProposalModel } from "./models/proposals.model";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { Subscription } from "rxjs";
import { auditTime } from "rxjs/operators";
import { ProposalsService } from "src/app/pages/proposals/services/proposals.service";
import { TranslateService } from "@ngx-translate/core";
import Swal from "sweetalert2";
import { environment } from "src/environments/environment";
import { PropertiesService } from "../../services/properties.services";
import { PermissionsService } from "src/app/core/services/permissions.service";
import { EventService } from "src/app/core/services/event.service";
import { PropertyDataService } from "src/app/core/services/property-data.service";
import { moveItemInArray } from "@angular/cdk/drag-drop";
import { PaymentConditionsModel } from "../../models/payment-conditions.model";
import { ToastService } from "src/app/shared/toasts/toast-service";

@Component({
  selector: "app-proposals",
  templateUrl: "./proposals.component.html",
  styleUrls: ["./proposals.component.scss"],
})
export class ProposalsComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() property: any;
  @Input() propertyProposalsData!: ProposalModel[];
  @Input() detailsForm: any;
  @Input() statusList!: any[];
  @Input() typeRent: any;
  @Input() agents!: any[];
  @Input() allAgents!: any[];
  @Input() openProposal!: any;
  @Input() dataToFormInitDetails: any;
  @Input() propertyAgentsData: any;

  paymentsConditions?: PaymentConditionsModel[];

  proposalSelected!: ProposalModel | null;
  counterProposalForm!: FormGroup;
  workflowStepForm!: FormGroup;
  uploadWorkflowDocumentForm!: FormGroup;
  stores: any;
  workflowMode: "accept-and-step" | "step" = "step";

  subscription: Subscription = new Subscription();
  submitedCounter: boolean = false;
  submitedWorkflow: boolean = false;
  submitedUploadDocument: boolean = false;
  openNewProposal = false;
  proposalDealContext: any = null;

  /**
   * Horário de recebimento de propostas herdado do empreendimento a que esta
   * fração pertence. `null` quando não há restrição.
   */
  proposalsWindow: any = null;
  private proposalsWindowTimer: any = null;
  proposalDraftData: any = null;
  counterFormChangesSub?: Subscription;

  dirProposalsFiles = `${environment.apiUrl}/proposals/file/`;
  pathProfileImage = `${environment.apiUrl}/${environment.dirProfileImage}/`;

  loginUser!: {
    id?: string;
    role?: { id?: string; name?: string };
    stores?: any;
  };

  @ViewChild('saleFormModal') saleFormModal: any;

  bkpList!: ProposalModel[];

  rentIds!: any[];
  saleId: any;

  //

  openNewAgent: { listing: boolean; selling: boolean } = {
    listing: false,
    selling: false,
  };
  selected: { listing: any; selling: any } = { listing: null, selling: null };
  agentsExceptListing: any[] = [];
  agentsExceptSelling: any[] = [];
  saleFormGetAgentsFn = (type: "listing" | "selling") => this.getAgents(type);
  saleFormGetStoreByIdFn = (id: any) => this.getStoreById(id);
  saleFormGetSuffixFn = () => this.getSuffix();
  currencies: any;
  @Output() agentsChange: EventEmitter<any> = new EventEmitter<any>();
  propertyDetailsForm: any;
  modalCheck!: NgbModalRef;
  private proposalDetailsCache = new WeakMap<object, Array<{ label: string; value: any }>>();
  private proposalProposersCache = new WeakMap<object, any[]>();

  constructor(
    private modalService: NgbModal,
    private formBuilder: FormBuilder,
    private proposalsService: ProposalsService,
    private translateService: TranslateService,
    private propertiesService: PropertiesService,
    public permissionsService: PermissionsService,
    private eventService: EventService,
    private propertyData: PropertyDataService,
    private toastService: ToastService,
  ) { }

  ngOnInit(): void {
    // normaliza agentes
    this.agents = this.agents.map((a) => ({
      ...a,
      isListing: a.isListingAgent,
      isSelling: a.isSellingAgent,
      listingCom: a.listingCommission,
      saleCom: a.saleCommission,
    }));

    this.allAgents = this.allAgents.map((a) => ({
      ...a,
      isListing: a.isListingAgent,
      isSelling: a.isSellingAgent,
      listingCom: a.listingCommission,
      saleCom: a.saleCommission,
    }));

    const { id, role, stores } = this.propertiesService.getUserAuth();
    this.loginUser = { id, role, stores };
    this.bkpList = this.propertyProposalsData;
    this.loadProposalsWindow();
    this.currencies = this.dataToFormInitDetails?.currencies;
    this.stores = this.dataToFormInitDetails?.stores;
    this.saleId = this.dataToFormInitDetails?.saleId;
    this.rentIds = this.dataToFormInitDetails?.rentIds;

    // carrega condições financeiras iniciais (para render do bloco no lado direito)
    this.paymentsConditions = this.detailsForm?.data?.paymentsConditions ?? [];

    this.subscription.add(
      this.eventService.subscribe("new-proposal-closed", () => {
        this.openNewProposal = false;
        this.proposalDealContext = null;
        this.proposalDraftData = null;
        this.syncProposalTabData();
        this.reloadProposalsFromProperty();
      }),
    );

    this.subscription.add(
      this.eventService.subscribe("proposal-form-updated", (proposalDraft) => {
        this.proposalDraftData = proposalDraft;
        this.syncProposalTabData();
      }),
    );

    this.syncProposalTabData();
  }

  ngAfterViewInit(): void {
    if (this.openProposal) {
      const find = this.propertyProposalsData.find(
        (f) => f.id == this.openProposal,
      );
      if (find) {
        const el = document.getElementById(`proposal-${this.openProposal}`);
        el?.click();
      }
      this.eventService.broadcast("clear-open-proposal");
    }
  }

  isRentProperty() {
    return this.typeRent === this.detailsForm?.data?.businessType;
  }

  onChangestatus(event: any) {
    this.clearProposalDetailsCache();
    this.proposalSelected = null;
    if (event?.id) {
      this.propertyProposalsData = this.bkpList.filter(
        (p) => p?.history && p?.history[0]?.proposalStatusId === event.id,
      );
    } else {
      this.propertyProposalsData = this.bkpList;
    }
  }

  /**
   * Guarda a janela e agenda o desbloqueio para a hora de abertura, para que uma
   * página deixada aberta não fique presa em "Propostas a partir de ...".
   */
  private setProposalsWindow(data: any) {
    clearTimeout(this.proposalsWindowTimer);
    this.proposalsWindow = data ?? null;
    this.proposalsWindowTimer = scheduleProposalsWindowUnlock(
      this.proposalsWindow,
      () => (this.proposalsWindow = { ...this.proposalsWindow, blocked: false }),
    );
  }

  private loadProposalsWindow() {
    if (!this.property?.id) {
      return;
    }
    this.subscription.add(
      this.propertiesService.getProposalsWindow(this.property.id).subscribe({
        next: (data) => this.setProposalsWindow(data),
      }),
    );
  }

  /** New Proposal */
  newProposal() {
    if (this.proposalsWindow?.blocked) {
      return;
    }

    const openProposalModal = (sourceProperty?: any) => {
      this.openNewProposal = true;
      this.proposalDealContext = this.buildProposalDealContext(sourceProperty);
    };

    if (!this.property?.id) {
      openProposalModal();
      return;
    }

    const sub = this.propertiesService.findOne(this.property.id).subscribe({
      next: (propertyData) => openProposalModal(propertyData),
      // fallback para os dados ja em memoria caso a chamada falhe
      error: () => openProposalModal(),
    });
    this.subscription.add(sub);
  }

  private buildProposalDealContext(sourceProperty?: any) {
    const detailsData = this.detailsForm?.data ?? {};
    const propertyInput = sourceProperty ?? this.property ?? {};
    const baseProperty = this.property ?? {};
    const normalizedBusinessType = this.resolveProposalBusinessType(
      propertyInput,
      detailsData,
    );

    const propertyData = {
      ...detailsData,
      ...propertyInput,
      id: this.pickFirst(
        propertyInput?.id,
        propertyInput?.details?.id,
        baseProperty?.id,
        detailsData?.id,
      ),
      ref: this.pickFirst(
        propertyInput?.ref,
        propertyInput?.reference,
        propertyInput?.details?.ref,
        propertyInput?.details?.reference,
        baseProperty?.ref,
        baseProperty?.reference,
        detailsData?.ref,
        detailsData?.reference,
      ),
      store: this.pickFirst(
        propertyInput?.store,
        propertyInput?.details?.store,
        baseProperty?.store,
        detailsData?.store,
      ),
      price: this.pickFirst(
        propertyInput?.price,
        propertyInput?.details?.price,
        baseProperty?.price,
        detailsData?.price,
      ),
      businessType: this.pickFirst(
        normalizedBusinessType,
        detailsData?.businessType,
        propertyInput?.businessType,
        propertyInput?.propertyBusinessTypeId,
      ),
      location: this.pickFirst(
        propertyInput?.location,
        propertyInput?.details?.location,
        baseProperty?.location,
        detailsData?.location,
      ),
      typeRent: this.typeRent,
    };

    const mainAgentName = this.pickFirst(
      propertyData?.mainAgent?.name,
      propertyData?.mainAgentName,
      propertyData?.agentName,
      baseProperty?.mainAgent?.name,
      baseProperty?.mainAgentName,
      baseProperty?.agentName,
    );
    const defaultContact = this.resolveDefaultProposalContact(
      propertyInput,
      baseProperty,
    );

    return {
      property: propertyData,
      agent: mainAgentName ? { name: mainAgentName } : null,
      contact: defaultContact,
    };
  }

  private resolveProposalBusinessType(
    propertyInput: any,
    detailsData: any,
  ): "SALE" | "RENT" | null {
    const normalizedFromText = this.normalizeBusinessTypeValue(
      this.pickFirst(
        propertyInput?.businessType,
        detailsData?.businessTypeData?.description,
        propertyInput?.propertyBusinessType?.description,
        propertyInput?.propertyBusinessType
          ?.propertyBusinessTypeTranslations?.[0]?.description,
        propertyInput?.details?.businessTypeData?.description,
        propertyInput?.details?.propertyBusinessType?.description,
      ),
    );

    if (normalizedFromText) {
      return normalizedFromText;
    }

    const businessTypeId = Number(
      this.pickFirst(
        detailsData?.businessType,
        propertyInput?.details?.businessType,
        propertyInput?.propertyBusinessTypeId,
        propertyInput?.propertyBusinessType?.id,
        propertyInput?.businessTypeData?.id,
        propertyInput?.details?.businessTypeData?.id,
        propertyInput?.businessType,
      ),
    );
    const rentTypeId = Number(this.typeRent);

    if (
      Number.isFinite(businessTypeId) &&
      businessTypeId > 0 &&
      Number.isFinite(rentTypeId) &&
      rentTypeId > 0
    ) {
      return businessTypeId === rentTypeId ? "RENT" : "SALE";
    }

    if (Number.isFinite(businessTypeId) && businessTypeId > 0) {
      return "SALE";
    }

    return null;
  }

  private normalizeBusinessTypeValue(value: any): "SALE" | "RENT" | null {
    if (value === null || value === undefined) {
      return null;
    }

    const normalizedValue = `${value}`.trim().toUpperCase();
    if (!normalizedValue) {
      return null;
    }

    if (
      normalizedValue.includes("SALE") ||
      normalizedValue.includes("SELL") ||
      normalizedValue.includes("VENDA")
    ) {
      return "SALE";
    }

    if (
      normalizedValue.includes("RENT") ||
      normalizedValue.includes("LEASE") ||
      normalizedValue.includes("ARREND")
    ) {
      return "RENT";
    }

    return null;
  }

  private pickFirst<T>(...values: T[]): T | undefined {
    return values.find((value) => value !== undefined && value !== null);
  }

  private resolveDefaultProposalContact(propertyInput: any, baseProperty: any) {
    const contactList = this.pickFirst(
      propertyInput?.propertyCostumersContacts?.costumers,
      baseProperty?.propertyCostumersContacts?.costumers,
      propertyInput?.costumers?.costumers,
      baseProperty?.costumers?.costumers,
    );

    if (!Array.isArray(contactList) || contactList.length === 0) {
      return null;
    }

    const selectedContact =
      contactList.find((contact: any) => contact?.isSelected === true) ??
      contactList[0];

    return this.mapProposalContact(selectedContact);
  }

  private mapProposalContact(contact: any) {
    if (!contact) {
      return null;
    }

    const firstName = contact?.firstName ?? null;
    const lastName = contact?.lastName ?? null;
    const fallbackName = [firstName, lastName].filter(Boolean).join(" ").trim();
    const name =
      contact?.name ?? contact?.fullName ?? (fallbackName ? fallbackName : null);

    return {
      id: contact?.id,
      name,
      firstName,
      lastName,
      fullName: name,
      email: contact?.email ?? null,
      phone:
        contact?.phone ??
        contact?.phoneNumber ??
        contact?.phoneNumber1 ??
        contact?.phoneNumber2 ??
        null,
      phoneNumber:
        contact?.phoneNumber ??
        contact?.phone ??
        contact?.phoneNumber1 ??
        contact?.phoneNumber2 ??
        null,
      fiscalIdentification: contact?.fiscalIdentification ?? null,
      docType: contact?.docType ?? null,
      docNumber: contact?.docNumber ?? contact?.identificationDocument ?? null,
      docExpiration: contact?.docExpiration ?? null,
      maritalStatus: contact?.maritalStatus ?? null,
      propertyRegime: contact?.propertyRegime ?? null,
      naturalness: contact?.naturalness ?? null,
      nationality: contact?.nationality ?? null,
      address: contact?.address ?? null,
      city: contact?.city ?? null,
      postalCode: contact?.postalCode ?? contact?.zipCode ?? null,
      country: contact?.country ?? contact?.fiscalCountry ?? null,
      fiscalAddress: contact?.fiscalAddress ?? null,
      fiscalCity: contact?.fiscalCity ?? null,
      fiscalPostalCode: contact?.fiscalPostalCode ?? null,
      fiscalCountry: contact?.fiscalCountry ?? null,
      occupation: contact?.occupation ?? null,
      employer: contact?.employer ?? null,
      actionType: contact?.actionType ?? null,
      actionTypeOther: contact?.actionTypeOther ?? null,
      politicalPositions: contact?.politicalPositions ?? false,
      politicalDesc: contact?.politicalDesc ?? null,
      company: contact?.company ?? null,
      companyFiscalIdentification: contact?.companyFiscalIdentification ?? null,
      permanentRegistry: contact?.permanentRegistry ?? null,
    };
  }

  private reloadProposalsFromProperty() {
    if (!this.property?.id) {
      return;
    }

    const sub = this.propertiesService.findOne(this.property.id).subscribe({
      next: (propertyData) => {
        const proposals = propertyData?.proposals ?? [];
        this.clearProposalDetailsCache();
        this.propertyProposalsData = proposals;
        this.bkpList = proposals;
        this.eventService.broadcast("update-proposals", proposals);
      },
      error: () => this.errorMsg(this.translateService.instant("t-error-creating")),
    });
    this.subscription.add(sub);
  }

  private syncProposalTabData() {
    this.propertyData.updateTab("proposals", {
      proposal: this.proposalDraftData,
      counter: this.counterProposalForm?.getRawValue() ?? null,
    });
  }

  getProposalStatusLabel(status: any): string {
    const translateKey = this.getProposalStatusTranslationKey(status);
    return translateKey ?? status?.proposalStatus ?? "";
  }

  private getProposalStatusTranslationKey(status: any): string | null {
    const normalizedStatus = String(
      status?.proposalStatusCode ??
      status?.originalStatus ??
      status?.proposalStatus ??
      "",
    )
      .trim()
      .toLowerCase();

    if (!normalizedStatus) {
      return null;
    }

    if (normalizedStatus === "reserved" || normalizedStatus.includes("reserv")) {
      return "t-proposals.t-status-reserved";
    }

    if (
      normalizedStatus === "sale agreement" ||
      normalizedStatus.replace(/\s+/g, "") === "saleagreement" ||
      normalizedStatus === "cpcv"
    ) {
      return this.isRentProposal(null)
        ? "t-proposals.t-status-lease-agreement"
        : "t-proposals.t-status-cpcv";
    }

    return null;
  }

  /** Counter Proposal */
  counterProposal(content: any, proposal: ProposalModel) {
    this.initCounterForm(proposal);
    this.modalService.open(content, {
      size: "md",
      centered: true,
      backdropClass: "custom-modal",
    });
  }

  initCounterForm(proposal: ProposalModel) {
    this.counterProposalForm = this.formBuilder.group({
      proposalId: [proposal.id],
      clientName: [proposal.clientName],
      value: [null, [Validators.required, Validators.min(1)]],
      obs: [null],
      file: [null],
    });
    if (proposal.agencyProposal) {
      const lastVal = proposal.lastAction
        ? proposal.lastAction.saleDivision
        : proposal.firstProposal
          ? proposal.firstProposal.saleDivision
          : 50;
      this.counterProposalForm.setControl(
        "saleDivision",
        new FormControl(lastVal, [Validators.required]),
      );
    }

    this.counterFormChangesSub?.unsubscribe();
    this.counterFormChangesSub = this.counterProposalForm.valueChanges
      .pipe(auditTime(150))
      .subscribe(() => this.syncProposalTabData());
    this.subscription.add(this.counterFormChangesSub);
    this.syncProposalTabData();
  }

  get formCounter() {
    return this.counterProposalForm.controls;
  }

  submitCounterProposal() {
    this.submitedCounter = true;
    if (this.counterProposalForm.valid) {
      const formData = new FormData();
      const proposalId = this.counterProposalForm.get("proposalId")?.value;
      formData.append("value", this.counterProposalForm.get("value")?.value);
      if (this.counterProposalForm.get("obs")?.value)
        formData.append("obs", this.counterProposalForm.get("obs")?.value);
      if (this.counterProposalForm.get("file")?.value)
        formData.append("file", this.counterProposalForm.get("file")?.value);
      if (this.counterProposalForm.get("saleDivision")?.value)
        formData.append(
          "saleDivision",
          this.counterProposalForm.get("saleDivision")?.value,
        );

      this.proposalsService.counterProposal(proposalId, formData).subscribe({
        next: (data: ProposalModel) => {
          this.submitedCounter = false;
          document.getElementById("proposal-dismiss-btn")?.click();
          const find = this.propertyProposalsData.find(
            (p) => p.id === proposalId,
          );
          if (find && data.history) {
            find.history?.unshift(data.history[0]);
            find.lastAction = data.history[0];
          }
          this.eventService.broadcast(
            "update-proposals",
            this.propertyProposalsData,
          );
        },
        error: () =>
          this.errorMsg(this.translateService.instant("t-error-creating")),
      });
    }
  }

  clearFormCounter() {
    this.counterProposalForm.reset();
  }

  addFileCostumer() {
    document.getElementById("input-filec")?.click();
  }

  onFileChangeCounter(event: any) {
    if (event.target.files && event.target.files.length) {
      const [file] = event.target.files;
      this.counterProposalForm.patchValue({ file });
    }
    event.target.value = "";
  }

  deleteFileCounter() {
    this.counterProposalForm.patchValue({ file: null });
  }

  /** "Obs", "Motivo da recusa" ou "Motivo do cancelamento", conforme a entrada. */
  obsLabelKey(entry: any, history: any[] | null | undefined): string {
    return proposalHistoryObsLabelKey(entry, history);
  }

  /**
   * Refuse Proposal — o motivo (opcional) fica no histórico da proposta.
   * `afterAcceptance`: o botão diz "Cancelar" (proposta já aceite) e os
   * textos são os de cancelar.
   */
  refuseProposal(proposalId: any, value: any, afterAcceptance = false) {
    Swal.fire({
      title: this.translateService.instant(afterAcceptance ? "t-proposals.t-cancel-title" : "t-proposals.t-refuse-title"),
      text: this.translateService.instant("t-proposals.t-refuse-text"),
      icon: "warning",
      input: "textarea",
      inputLabel: this.translateService.instant(afterAcceptance ? "t-proposals.t-cancel-reason" : "t-proposals.t-refuse-reason"),
      inputPlaceholder: this.translateService.instant(afterAcceptance ? "t-proposals.t-cancel-reason" : "t-proposals.t-refuse-reason"),
      showCancelButton: true,
      confirmButtonColor: "#008a00",
      cancelButtonColor: "#f46a6a",
      confirmButtonText: this.translateService.instant(afterAcceptance ? "t-proposals.t-cancel-confirm" : "t-proposals.t-refuse-confirm"),
      cancelButtonText: this.translateService.instant(
        "t-proposals.t-refuse-cancel",
      ),
    }).then((result) => {
      // Com input, `value` é o texto: vazio sem motivo, mas confirmado.
      if (result.isConfirmed) {
        const reason = `${result.value ?? ""}`.trim();
        this.proposalsService.declineProposal(proposalId, value, reason).subscribe({
          next: (data: {
            proposal: ProposalModel;
            status: boolean | number;
          }) => {
            if (data?.proposal.history) {
              const find = this.propertyProposalsData.find(
                (p) => p.id === proposalId,
              );
              if (find) {
                find.history?.unshift(data.proposal.history[0]);
                find.lastAction = data.proposal.history[0];
              }
              this.eventService.broadcast(
                "update-proposals",
                this.propertyProposalsData,
              );
            }
            if (data?.status !== false && !isNaN(Number(data?.status))) {
              if (this.detailsForm) {
                this.detailsForm.data.businessStatus = Number(data.status);
                this.eventService.broadcast("can-change-business-status", true);
              }
            }
          },
          error: () =>
            this.errorMsg(this.translateService.instant("t-error-creating")),
        });
      }
    });
  }

  /** Delete Proposal */
  deleteProposal(id: any) {
    Swal.fire({
      title: this.translateService.instant("t-proposals.t-delete-title"),
      text: this.translateService.instant("t-proposals.t-delete-text"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#008a00",
      cancelButtonColor: "#f46a6a",
      confirmButtonText: this.translateService.instant(
        "t-proposals.t-delete-confirm",
      ),
      cancelButtonText: this.translateService.instant(
        "t-proposals.t-delete-cancel",
      ),
    }).then((result) => {
      if (result.value) {
        this.proposalsService.deleteProposal(id).subscribe({
          next: (data: { status?: boolean | number }) => {
            this.proposalSelected = null;
            this.propertyProposalsData = this.propertyProposalsData.filter(
              (p) => p.id !== id,
            );
            this.bkpList = this.bkpList.filter((p) => p.id !== id);
            this.eventService.broadcast(
              "update-proposals",
              this.propertyProposalsData,
            );
            if (data.status !== false && !isNaN(Number(data.status))) {
              this.detailsForm.data.businessStatus = Number(data.status);
              this.eventService.broadcast("can-change-business-status", true);
            }
          },
          error: () =>
            this.errorMsg(this.translateService.instant("t-delete-error")),
        });
      }
    });
  }

  private getHistoryTimestamp(history: any): number {
    const timestamp = history?.date ? new Date(history.date).getTime() : NaN;
    return Number.isFinite(timestamp) ? timestamp : 0;
  }

  getLatestHistory(proposal: ProposalModel | null) {
    const history = proposal?.history ?? [];
    if (!Array.isArray(history) || history.length === 0) {
      return null;
    }

    return history.reduce((latest: any, current: any) => {
      const latestTime = this.getHistoryTimestamp(latest);
      const currentTime = this.getHistoryTimestamp(current);

      if (currentTime === latestTime) {
        return Number(current?.id ?? 0) > Number(latest?.id ?? 0) ? current : latest;
      }

      return currentTime > latestTime ? current : latest;
    }, history[0]);
  }

  isLatestHistoryEntry(history: any, proposal: ProposalModel | null): boolean {
    const latest = this.getLatestHistory(proposal);
    if (!latest || !history) {
      return false;
    }

    const latestId = this.normalizeIdentifier(latest?.id).toLowerCase();
    const historyId = this.normalizeIdentifier(history?.id).toLowerCase();
    if (latestId && historyId) {
      return latestId === historyId;
    }

    return this.getHistoryTimestamp(latest) === this.getHistoryTimestamp(history);
  }

  isRentProposal(_proposal: ProposalModel | null) {
    return this.isRentProperty() || this.property?.isRent === true;
  }

  private hasReservationPaymentCondition() {
    const payments =
      this.detailsForm?.data?.paymentsConditions ??
      this.paymentsConditions ??
      this.property?.paymentsConditions ??
      [];

    return (payments ?? []).some((payment: any) => {
      const type = `${payment?.type ?? ""}`.toUpperCase();
      const moment = `${payment?.paymentMoment ?? ""}`.toUpperCase();
      return type === "RESERVATION" || moment.includes("RESERV");
    });
  }

  private getDefaultNextWorkflowStatus(
    proposal: ProposalModel | null,
  ): "Reserved" | "Sale Agreement" {
    const latest = this.getLatestHistory(proposal);
    const statusCode = this.normalizeWorkflowStatusCode(
      latest?.proposalStatusCode,
    );

    if (statusCode === "reserved") {
      return "Sale Agreement";
    }

    if (statusCode === "accepted") {
      return this.hasReservationPaymentCondition()
        ? "Reserved"
        : "Sale Agreement";
    }

    return "Reserved";
  }

  private normalizeWorkflowStatusCode(statusCode: any): string {
    const normalized = String(statusCode ?? "")
      .trim()
      .toLowerCase()
      .replace(/[\s_-]+/g, "");

    if (normalized === "cpcv") {
      return "saleagreement";
    }

    return normalized;
  }

  private getProposalSenderIdCandidates(proposal: ProposalModel | null): string[] {
    const firstProposalHistory =
      proposal?.firstProposal ??
      proposal?.history?.find(
        (history: any) =>
          this.normalizeWorkflowStatusCode(history?.proposalStatusCode) ===
          "firstproposal",
      );

    return [
      proposal?.userId,
      proposal?.user?.id,
      proposal?.createdBy,
      firstProposalHistory?.user?.id,
      firstProposalHistory?.user,
      firstProposalHistory?.createdBy,
    ]
      .map((value) => this.normalizeIdentifier(value).toLowerCase())
      .filter(Boolean);
  }

  private isProposalSender(proposal: ProposalModel | null): boolean {
    const currentUserId = this.normalizeIdentifier(this.loginUser?.id).toLowerCase();
    if (!currentUserId) {
      return false;
    }

    return this.getProposalSenderIdCandidates(proposal).includes(currentUserId);
  }

  private getProposalStoreId(proposal: ProposalModel | null): any {
    const proposalAny = proposal as any;
    const propertyAny = this.property as any;

    return (
      proposalAny?.property?.store?.id ??
      proposalAny?.property?.storeId ??
      propertyAny?.store?.id ??
      propertyAny?.storeId ??
      propertyAny?.store ??
      null
    );
  }

  private canOverrideSenderRestriction(proposal: ProposalModel | null): boolean {
    return this.permissionsService.checkMasterSomePermissions(
      ["ACCEPT_PROPOSALS", "REJECT_PROPOSALS", "VALIDATE_PROPOSALS", "MAKE_COUNTEROFFER"],
      this.getProposalStoreId(proposal),
    );
  }

  private isDocumentPending(history: any): boolean {
    if (history?.documentPending !== undefined && history?.documentPending !== null) {
      return !!history?.documentPending;
    }

    return (
      !!history?.requiresDocument &&
      !history?.documentDeliveredAt &&
      (!history?.file || history?.file?.length === 0) &&
      !history?.expiredAt
    );
  }

  canDecideProposal(proposal: ProposalModel | null): boolean {
    if (this.canOverrideSenderRestriction(proposal)) {
      return true;
    }
    return !this.isProposalSender(proposal);
  }

  canOpenWorkflowFromAccept(proposal: ProposalModel | null) {
    const latest = this.getLatestHistory(proposal);
    if (!latest) return false;
    const statusCode = this.normalizeWorkflowStatusCode(latest.proposalStatusCode);

    return ![
      "accepted",
      "reserved",
      "saleagreement",
      "declined",
      "salecompleted",
    ].includes(statusCode);
  }

  canAdvanceWorkflowStep(proposal: ProposalModel | null) {
    const latest = this.getLatestHistory(proposal);
    if (!latest) return false;
    if (this.isProposalSender(proposal) && !this.canOverrideSenderRestriction(proposal)) return false;
    if (this.property?.saleInProgress) return false;
    const statusCode = this.normalizeWorkflowStatusCode(latest.proposalStatusCode);
    const hasPendingDocument = this.isDocumentPending(latest);

    if (statusCode === "accepted") return true;
    if (statusCode === "reserved") return !hasPendingDocument;

    return false;
  }

  canCheckWorkflowProposal(proposal: ProposalModel | null) {
    const latest = this.getLatestHistory(proposal);
    if (!latest) return false;
    if (this.isProposalSender(proposal) && !this.canOverrideSenderRestriction(proposal)) return false;
    const statusCode = this.normalizeWorkflowStatusCode(latest.proposalStatusCode);
    const hasPendingDocument = this.isDocumentPending(latest);

    return (
      statusCode === "saleagreement" &&
      !hasPendingDocument &&
      !this.property?.saleInProgress
    );
  }

  /** "Aguardar documento": cancelar continua possível (o servidor já aceita). */
  canCancelPendingDocument(proposal: ProposalModel | null) {
    const latest = this.getLatestHistory(proposal);
    if (!latest || !this.isDocumentPending(latest)) return false;
    if (this.isProposalSender(proposal) && !this.canOverrideSenderRestriction(proposal)) return false;
    if (this.property?.saleInProgress) return false;
    const statusCode = this.normalizeWorkflowStatusCode(latest.proposalStatusCode);
    return ["accepted", "reserved", "saleagreement"].includes(statusCode);
  }

  canUploadPendingDocument(proposal: ProposalModel | null) {
    const latest = this.getLatestHistory(proposal);
    const hasPendingDocument = this.isDocumentPending(latest);
    const isProposalSender = this.isProposalSender(proposal);
    const canValidate =
      !!proposal &&
      (this.permissionsService.checkMasterPermission(
        "VALIDATE_PROPOSALS",
        this.property?.store?.id,
      ) ||
        this.permissionsService.checkAgentPermission(
          this.property?.mainAgent,
          "VALIDATE_PROPOSALS",
        ));
    const isCommercialDirectorWithValidationPermission =
      this.permissionsService.currentRole === "COMMERCIAL DIRECTOR" &&
      this.permissionsService.hasPermission("VALIDATE_PROPOSALS");

    return (
      (hasPendingDocument || (!!latest?.requiresDocument && this.hasStepFiles(latest))) &&
      (isProposalSender ||
        canValidate ||
        isCommercialDirectorWithValidationPermission)
    );
  }

  isDocumentRequested(history: any) {
    return !!history?.requiresDocument;
  }

  onWorkflowDocumentToggle() {
    if (!this.workflowStepForm.get("requestDocument")?.value) {
      this.workflowStepForm.patchValue({
        useDeadline: false,
        documentDeadline: null,
      });
    }
  }

  onFileChangeWorkflow(event: any) {
    this.appendFiles(this.workflowStepForm, event);
  }

  deleteWorkflowFile(index: number) {
    this.removeFileAt(this.workflowStepForm, index);
  }

  onFileChangeUploadWorkflow(event: any) {
    this.appendFiles(this.uploadWorkflowDocumentForm, event);
  }

  deleteUploadWorkflowFile(index: number) {
    this.removeFileAt(this.uploadWorkflowDocumentForm, index);
  }

  /**
   * Vários ficheiros por passo (CPCV com mais de um anexo): a seleção
   * acumula, sem repetir o mesmo ficheiro (nome + tamanho).
   */
  private appendFiles(form: any, event: any): void {
    const picked: File[] = Array.from((event?.target?.files ?? []) as FileList);
    if (picked.length) {
      const current: File[] = Array.isArray(form?.get("files")?.value)
        ? [...form.get("files").value]
        : [];
      for (const file of picked) {
        if (!current.some((f) => f.name === file.name && f.size === file.size)) {
          current.push(file);
        }
      }
      form?.patchValue({ files: current });
    }
    if (event?.target) {
      event.target.value = "";
    }
  }

  private removeFileAt(form: any, index: number): void {
    const current: File[] = Array.isArray(form?.get("files")?.value)
      ? [...form.get("files").value]
      : [];
    current.splice(index, 1);
    form?.patchValue({ files: current });
  }

  /** O passo já tem documentos: o botão passa a "juntar documentos". */
  hasStepFiles(history: any): boolean {
    return Array.isArray(history?.file) && history.file.length > 0;
  }

  openWorkflowStep(content: any, mode: "accept-and-step" | "step" = "step") {
    if (!this.proposalSelected?.id) {
      return;
    }

    this.workflowMode = mode;
    const latest = this.getLatestHistory(this.proposalSelected);
    const nextStatus = this.getDefaultNextWorkflowStatus(this.proposalSelected);

    this.workflowStepForm = this.formBuilder.group({
      proposalId: [this.proposalSelected.id, Validators.required],
      status: [
        {
          value: nextStatus,
          disabled: latest?.proposalStatusCode === "Reserved",
        },
        Validators.required,
      ],
      obs: [null],
      requestDocument: [false],
      useDeadline: [false],
      documentDeadline: [null],
      files: [[] as File[]],
    });

    this.submitedWorkflow = false;
    this.modalService.open(content, {
      size: "lg",
      centered: true,
      backdropClass: "custom-modal",
    });
  }

  submitWorkflowStep() {
    this.submitedWorkflow = true;
    if (!this.workflowStepForm.valid) {
      return;
    }

    const proposalId = this.workflowStepForm.get("proposalId")?.value;

    const executeStep = () => {
      const formData = new FormData();
      const rawStatus = this.workflowStepForm.getRawValue()?.status;
      if (rawStatus) {
        formData.append("status", rawStatus);
      }
      if (
        this.workflowMode === "step" &&
        this.workflowStepForm.get("obs")?.value
      ) {
        formData.append("obs", this.workflowStepForm.get("obs")?.value);
      }
      formData.append(
        "requestDocument",
        `${!!this.workflowStepForm.get("requestDocument")?.value}`,
      );
      formData.append(
        "useDeadline",
        `${!!this.workflowStepForm.get("useDeadline")?.value}`,
      );
      if (this.workflowStepForm.get("documentDeadline")?.value) {
        formData.append(
          "documentDeadline",
          this.workflowStepForm.get("documentDeadline")?.value,
        );
      }
      for (const file of this.workflowStepForm.get("files")?.value ?? []) {
        formData.append("file", file);
      }

      this.proposalsService.advanceProposalWorkflowStep(proposalId, formData).subscribe({
        next: (proposal: ProposalModel) => {
          this.submitedWorkflow = false;
          document.getElementById("proposal-dismiss-btn")?.click();
          this.syncProposalState(proposalId, proposal);
        },
        error: () => {
          this.errorMsg(this.translateService.instant("t-error-updating"));
        },
      });
    };

    if (this.workflowMode === "accept-and-step") {
      this.proposalsService.acceptProposalWorkflow(proposalId, {
        obs: this.workflowStepForm.get("obs")?.value ?? null,
      }).subscribe({
        next: (proposal: ProposalModel) => {
          this.syncProposalState(proposalId, proposal);
          executeStep();
        },
        error: () => {
          this.errorMsg(this.translateService.instant("t-error-creating"));
        },
      });
      return;
    }

    executeStep();
  }

  openUploadWorkflowDocument(content: any, history: any) {
    this.uploadWorkflowDocumentForm = this.formBuilder.group({
      historyId: [history?.id, Validators.required],
      files: [[] as File[], (control: any) => (Array.isArray(control?.value) && control.value.length ? null : { required: true })],
      obs: [null],
    });
    this.submitedUploadDocument = false;
    this.modalService.open(content, {
      size: "md",
      centered: true,
      backdropClass: "custom-modal",
    });
  }

  submitUploadWorkflowDocument() {
    this.submitedUploadDocument = true;
    if (!this.uploadWorkflowDocumentForm.valid) {
      return;
    }

    const formData = new FormData();
    for (const file of this.uploadWorkflowDocumentForm.get("files")?.value ?? []) {
      formData.append("file", file);
    }
    if (this.uploadWorkflowDocumentForm.get("obs")?.value) {
      formData.append("obs", this.uploadWorkflowDocumentForm.get("obs")?.value);
    }

    const historyId = this.uploadWorkflowDocumentForm.get("historyId")?.value;
    this.proposalsService.uploadProposalWorkflowDocument(historyId, formData).subscribe({
      next: (proposal: ProposalModel) => {
        this.submitedUploadDocument = false;
        document.getElementById("proposal-dismiss-btn")?.click();
        this.syncProposalState(proposal.id, proposal);
      },
      error: () => {
        this.errorMsg(this.translateService.instant("t-error-updating"));
      },
    });
  }


  private syncProposalState(proposalId: any, proposal: ProposalModel) {
    const targetId = Number(proposalId);

    const patchList = (list: ProposalModel[] | undefined) => {
      if (!Array.isArray(list)) {
        return null;
      }
      const found = list.find((item) => Number(item?.id) === targetId);
      if (!found) {
        return null;
      }

      Object.assign(found, proposal);
      found.history = proposal.history ?? found.history;
      found.firstProposal = proposal.firstProposal ?? found.firstProposal;
      found.lastAction = proposal.lastAction ?? found.lastAction;
      return found;
    };

    const updatedMain = patchList(this.propertyProposalsData);
    patchList(this.bkpList);

    if (this.proposalSelected && Number(this.proposalSelected.id) === targetId) {
      const source = updatedMain ?? proposal;
      this.proposalSelected = {
        ...this.proposalSelected,
        ...source,
        history: source.history ?? this.proposalSelected.history,
        firstProposal: source.firstProposal ?? this.proposalSelected.firstProposal,
        lastAction: source.lastAction ?? this.proposalSelected.lastAction,
      };
    }

    this.updateBusinessStatusFromWorkflowProposal(updatedMain ?? proposal);
    this.eventService.broadcast("update-proposals", this.propertyProposalsData);
  }

  private updateBusinessStatusFromWorkflowProposal(proposal: ProposalModel) {
    const latest =
      proposal?.history?.[0] ?? proposal?.lastAction ?? proposal?.firstProposal;
    if (!latest) {
      return;
    }

    const statusCode = this.normalizeStatusCode(
      latest?.proposalStatusCode ?? latest?.originalStatus ?? latest?.proposalStatus,
    );

    if (!statusCode) {
      return;
    }

    if (statusCode.includes("declin") || statusCode.includes("cancel")) {
      this.eventService.broadcast("can-change-business-status", true);
      return;
    }

    if (
      statusCode.includes("accept") ||
      statusCode.includes("reserv") ||
      statusCode.includes("saleagreement") ||
      statusCode.includes("cpcv")
    ) {
      let businessStatusId: any = null;
      if (statusCode.includes("reserv")) {
        businessStatusId = this.findBusinessStatusIdByKeywords(["reserv"]);
      } else if (
        statusCode.includes("saleagreement") ||
        statusCode.includes("cpcv")
      ) {
        businessStatusId = this.findBusinessStatusIdByKeywords([
          "cpcv",
          "saleagreement",
          "promessa",
        ]);
      }

      if (this.detailsForm && businessStatusId) {
        this.detailsForm.data.businessStatus = businessStatusId;
      }
      this.eventService.broadcast("can-change-business-status", false);
    }
  }

  private findBusinessStatusIdByKeywords(keywords: string[]): any | null {
    const statuses = this.dataToFormInitDetails?.businessStatus ?? [];
    const normalizedKeywords = (keywords ?? []).map((keyword) =>
      this.normalizeStatusCode(keyword),
    );

    const found = statuses.find((status: any) => {
      const normalizedDescription = this.normalizeStatusCode(
        status?.description ?? status?.name,
      );
      return normalizedKeywords.some(
        (keyword) => !!keyword && normalizedDescription.includes(keyword),
      );
    });

    return found?.id ?? null;
  }

  private normalizeStatusCode(value: any): string {
    return String(value ?? "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/\s+/g, "")
      .toLowerCase();
  }

  /** Check Proposal — delegated to app-sale-form smart modal */
  onProposalChecked(event: any) {
    const { proposalId, proposal, saleId, formValues, listingAgents, sellingAgents } = event;

    if (proposal?.history) {
      const find = this.propertyProposalsData.find(p => p.id === proposalId);
      if (find) {
        find.history?.unshift(proposal.history[0]);
        find.lastAction = proposal.history[0];
      }
      this.eventService.broadcast('update-proposals', this.propertyProposalsData);
    }

    this.syncPropertyAgentsAfterProposalCheck(listingAgents, sellingAgents);

    if (saleId && this.detailsForm) {
      this.detailsForm.data.businessStatus = saleId;
      this.detailsForm.data.saleValue = formValues.saleValue;
      this.detailsForm.data.saleDate = formValues.saleDate;
      this.detailsForm.data.isPercentageCommission = formValues.isPercentageCommission;
      this.detailsForm.data.saleCommission = formValues.saleCommission;
      this.detailsForm.data.dealId = formValues?.dealId ?? null;
      if (formValues.agencyProposal) {
        this.detailsForm.data.splitCommissionValue = formValues.splitCommissionValue;
        this.detailsForm.data.partnerEntityName = formValues.partnerName;
        this.detailsForm.data.sharedSale = true;
        this.detailsForm.data.sharedCommission = formValues.saleDivision ? (100 - Number(formValues.saleDivision)) : null;
      }
      this.eventService.broadcast('can-change-business-status', false);
    }
    this.modalCheck.dismiss();
  }

  private syncPropertyAgentsAfterProposalCheck(
    listingAgents: any[],
    sellingAgents: any[],
  ): void {
    const listing = Array.isArray(listingAgents) ? listingAgents : [];
    const selling = Array.isArray(sellingAgents) ? sellingAgents : [];

    if (!Array.isArray(this.propertyAgentsData)) {
      this.propertyAgentsData = [];
    }

    this.propertyAgentsData = this.propertyAgentsData.map((agent: any) => ({
      ...agent,
      isListingAgent: false,
      isSellingAgent: false,
    }));

    const ensureAgentInProperty = (selectedAgent: any) => {
      const existing = this.propertyAgentsData.find((agent: any) =>
        this.isSameAgent(agent, selectedAgent),
      );

      if (existing) {
        return existing;
      }

      const fromAllAgents = (this.allAgents ?? []).find((agent: any) =>
        this.isSameAgent(agent, selectedAgent),
      );

      const base = fromAllAgents ?? selectedAgent ?? {};
      const normalizedId = base?.id ?? base?.userId ?? selectedAgent?.id ?? selectedAgent?.userId;
      const newAgent = {
        ...base,
        id: normalizedId,
        userId: base?.userId ?? normalizedId,
        add: true,
        isListingAgent: false,
        isSellingAgent: false,
        listingCommission: base?.listingCommission ?? base?.listingCom ?? 0,
        saleCommission: base?.saleCommission ?? base?.saleCom ?? 0,
      };

      this.propertyAgentsData.push(newAgent);
      return newAgent;
    };

    listing.forEach((selectedAgent: any) => {
      const target = ensureAgentInProperty(selectedAgent);
      target.isListingAgent = true;
      if (selectedAgent?.listingCommission !== undefined && selectedAgent?.listingCommission !== null) {
        target.listingCommission = selectedAgent.listingCommission;
      } else if (selectedAgent?.listingCom !== undefined && selectedAgent?.listingCom !== null) {
        target.listingCommission = selectedAgent.listingCom;
      }
    });

    selling.forEach((selectedAgent: any) => {
      const target = ensureAgentInProperty(selectedAgent);
      target.isSellingAgent = true;
      if (selectedAgent?.saleCommission !== undefined && selectedAgent?.saleCommission !== null) {
        target.saleCommission = selectedAgent.saleCommission;
      } else if (selectedAgent?.saleCom !== undefined && selectedAgent?.saleCom !== null) {
        target.saleCommission = selectedAgent.saleCom;
      }
    });

    this.agents = [...this.propertyAgentsData];
    this.refreshListings();
    this.agentsChange.emit(this.propertyAgentsData);
    this.eventService.broadcast('data-tab-agents', this.propertyAgentsData);
  }

  /** @deprecated — kept as tombstone placeholder; remove after verifying */
  /** Utilities */

  getDate(date: Date) {
    date = new Date(date);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    return `${day}/${month}/${year} ${hours}:${minutes}`;
  }

  changeProposalSelected(proposal: ProposalModel) {
    if (this.proposalSelected && proposal.id === this.proposalSelected.id) {
      this.proposalSelected = null;
    } else {
      this.proposalSelected = proposal;
    }
  }

  formatSizeUnits(bytes: any) {
    if (bytes >= 1073741824) bytes = (bytes / 1073741824).toFixed(2) + " GB";
    else if (bytes >= 1048576) bytes = (bytes / 1048576).toFixed(2) + " MB";
    else if (bytes >= 1024) bytes = (bytes / 1024).toFixed(2) + " KB";
    else if (bytes > 1) bytes = bytes + " bytes";
    else if (bytes == 1) bytes = bytes + " byte";
    else bytes = "0 bytes";
    return bytes;
  }

  getIconColor(icon: any) {
    if (icon) {
      switch (icon) {
        case "ri-close-circle-line":
          return "bg-danger";
        case "ri-check-double-line":
          return "bg-success";
        case "ri-trophy-line":
          return "bg-gold";
        default:
          return "bg-light text-success";
      }
    }
    return "bg-light text-success";
  }

  getBadge(icon: any) {
    if (icon) {
      switch (icon) {
        case "ri-close-circle-line":
          return "badge-soft-danger";
        case "ri-check-double-line":
          return "badge-soft-success";
        case "ri-trophy-line":
          return "badge-soft-gold";
        default:
          return "badge-soft-info";
      }
    }
    return "badge-soft-info";
  }

  priceFormat(propertyPrice: any) {
    if (propertyPrice || propertyPrice === 0) {
      const parts = propertyPrice.toString().split(".");
      const spaces = (v: any) =>
        String(v).replace(/(?!^)(?=(?:\d{3})+$)/g, " ");
      const int = spaces(parts[0]);
      return parts.length > 1 ? int + "," + parts[1] : int;
    }
    return propertyPrice;
  }

  generateProposalRef(id: any) {
    if (!id) return ``;
    const ref = id.toString().padStart(4, "0");
    return `#P${ref}`;
  }

  private hasProposalValue(value: any) {
    return value !== null && value !== undefined && value !== "";
  }

  getAdditionalProposalDetails(proposal: ProposalModel | null | undefined) {
    if (!proposal) return [];
    const cacheKey = proposal as object;
    const cached = this.proposalDetailsCache.get(cacheKey);
    if (cached) {
      return cached;
    }

    const details = [
      { label: this.translateService.instant("t-proposals.t-details-client"), value: proposal.clientName },
      { label: this.translateService.instant("t-proposals.t-details-license-ami-imo"), value: proposal.licenseImo },
      { label: this.translateService.instant("t-proposals.t-details-bank"), value: proposal.bank },
      { label: this.translateService.instant("t-proposals.t-details-financing"), value: proposal.financing },
      { label: this.translateService.instant("t-proposals.t-details-source-funds"), value: proposal.sourceFunds },
      { label: this.translateService.instant("t-proposals.t-details-cpcv-term"), value: proposal.promiseContractTime },
      { label: this.translateService.instant("t-proposals.t-details-signal-1"), value: this.formatSignalDetail(proposal.signalBooster, proposal.signalBoosterPercent) },
      { label: this.translateService.instant("t-proposals.t-details-signal-2"), value: this.formatSignalDetail(proposal.signalBooster2, proposal.signalBooster2Percent) },
      { label: this.translateService.instant("t-proposals.t-details-signal-3"), value: this.formatSignalDetail(proposal.signalBooster3, proposal.signalBooster3Percent) },
      { label: this.translateService.instant("t-proposals.t-details-signal-4"), value: this.formatSignalDetail(proposal.signalBooster4, proposal.signalBooster4Percent) },
      { label: this.translateService.instant("t-proposals.t-details-purpose"), value: this.formatProposalPurpose(proposal.purpose) },
      { label: this.translateService.instant("t-proposals.t-details-reserve-value"), value: this.formatFinancialDetail(proposal.reserveValue) },
      { label: this.translateService.instant("t-proposals.t-details-payment-method"), value: this.formatPaymentMethod(proposal.paymentMethod) },
      { label: this.translateService.instant("t-proposals.t-details-deed-term"), value: proposal.deedTime },
      { label: this.translateService.instant("t-proposals.t-details-start-date"), value: proposal.startDate ? this.getDate(proposal.startDate as any) : null },
      { label: this.translateService.instant("t-proposals.t-details-security-deposit"), value: this.formatFinancialDetail(proposal.securityDeposit) },
      { label: this.translateService.instant("t-proposals.t-details-contract-duration"), value: proposal.contractDuration },
      { label: this.translateService.instant("t-proposals.t-details-contract-renewal"), value: proposal.renewalDuration },
      { label: this.translateService.instant("t-proposals.t-details-mediation-store"), value: proposal.mediationStore },
      { label: this.translateService.instant("t-proposals.t-details-responsible"), value: proposal.responsible },
      { label: this.translateService.instant("t-proposals.t-details-partner-agency"), value: proposal.partnerEntityName },
    ];

    const filteredDetails = details.filter((item) => this.hasProposalValue(item.value));
    this.proposalDetailsCache.set(cacheKey, filteredDetails);
    return filteredDetails;
  }

  getProposalProposers(proposal: ProposalModel | null | undefined): any[] {
    if (!proposal) {
      return [];
    }
    const cacheKey = proposal as object;
    const cached = this.proposalProposersCache.get(cacheKey);
    if (cached) {
      return cached;
    }

    const proposers = (proposal as any)?.proposalProposers;
    const normalized = Array.isArray(proposers) ? proposers : [];
    this.proposalProposersCache.set(cacheKey, normalized);
    return normalized;
  }

  getProposalProposerName(proposer: any) {
    const contactName = [proposer?.contact?.firstName, proposer?.contact?.lastName]
      .filter(Boolean)
      .join(" ")
      .trim();

    return proposer?.name || proposer?.contact?.fullName || contactName || proposer?.company || "-";
  }

  getProposalProposerIdentifier(proposer: any) {
    return proposer?.fiscalIdentification ?? proposer?.companyFiscalIdentification ?? null;
  }

  getProposalProposerTypeLabel(proposer: any) {
    const proposerTypeMap: Record<string, string> = {
      LEGAL: "t-proposals.t-proposer-type-legal",
      EFFECTIVE_BENEFICIARY: "t-proposals.t-proposer-type-effective-beneficiary",
      FIATHER: "t-proposals.t-proposer-type-fiather",
      INDIVIDUAL: "t-proposals.t-proposer-type-individual",
    };
    const translationKey = proposerTypeMap[String(proposer?.type ?? "").toUpperCase()];
    if (!translationKey) return null;
    return this.getSafeLabel(translationKey, null);
  }

  private getSafeLabel(key: string, fallback: string | null = key) {
    const label = this.translateService.instant(key);
    if (!label || label === key || label.includes("?")) {
      return fallback;
    }
    return label;
  }

  private formatProposalPurpose(value: any) {
    const purposeMap: Record<string, string> = {
      PERMANENT: "t-proposals.t-purpose-permanent",
      SECONDARY: "t-proposals.t-purpose-secondary",
      INVESTMENT: "t-proposals.t-purpose-investment",
    };
    const translationKey = purposeMap[String(value ?? "").toUpperCase()];
    if (!translationKey) return value;
    return this.getSafeLabel(translationKey, value);
  }

  private formatPaymentMethod(value: any) {
    const paymentMethodMap: Record<string, string> = {
      CASH: "t-proposals.t-payment-method-cash",
      CHECK_REAL: "t-proposals.t-payment-method-check-real",
      CHECK_OWNER: "t-proposals.t-payment-method-check-owner",
      TRANSFER_REAL: "t-proposals.t-payment-method-transfer-real",
      TRANSFER_OWNER: "t-proposals.t-payment-method-transfer-owner",
    };
    const translationKey = paymentMethodMap[String(value ?? "").toUpperCase()];
    if (!translationKey) return value;
    return this.getSafeLabel(translationKey, value);
  }

  private formatSignalDetail(value: any, isPercent: any) {
    const percent = isPercent === true || `${isPercent}` === 'true';
    const num = Number(value);
    if (
      percent &&
      value !== null &&
      value !== undefined &&
      value !== '' &&
      !Number.isNaN(num) &&
      num !== 0
    ) {
      return `${value}%`;
    }
    return this.formatFinancialDetail(value);
  }

  private formatFinancialDetail(value: any) {
    const numericValue = this.parseNumericValue(value);
    if (numericValue === null) {
      return this.hasProposalValue(value) ? value : null;
    }

    if (numericValue === 0) {
      return null;
    }

    return `${this.priceFormat(numericValue)} €`;
  }

  private parseNumericValue(value: any): number | null {
    if (value === null || value === undefined || value === "") {
      return null;
    }

    if (typeof value === "number") {
      return Number.isFinite(value) ? value : null;
    }

    if (typeof value !== "string") {
      return null;
    }

    let normalized = value.trim().replace(/\s/g, "");
    if (!normalized) {
      return null;
    }

    const hasComma = normalized.includes(",");
    const hasDot = normalized.includes(".");

    if (hasComma && hasDot) {
      if (normalized.lastIndexOf(",") > normalized.lastIndexOf(".")) {
        normalized = normalized.replace(/\./g, "").replace(",", ".");
      } else {
        normalized = normalized.replace(/,/g, "");
      }
    } else if (hasComma) {
      normalized = normalized.replace(",", ".");
    }

    const parsed = Number(normalized);
    return Number.isFinite(parsed) ? parsed : null;
  }

  private clearProposalDetailsCache() {
    this.proposalDetailsCache = new WeakMap<object, Array<{ label: string; value: any }>>();
    this.proposalProposersCache = new WeakMap<object, any[]>();
  }

  showAlertSuccess(msg: string) {
    Swal.fire({
      icon: "success",
      title: msg,
      showConfirmButton: false,
      timer: 1500,
    });
  }

  errorMsg(errorMsg: string) {
    Swal.fire({
      title: this.translateService.instant("t-something-wrong"),
      text: errorMsg,
      icon: "warning",
      confirmButtonColor: "rgb(54, 69, 116)",
      confirmButtonText: this.translateService.instant("t-close"),
    });
  }

  /** preço atual (considera venda/reserva com saleValue) */
  private getCurrentPrice(): number {
    const d = this.detailsForm?.data ?? {};

    return d.saleValue ? Number(d.saleValue) : Number(d.price) || 0;
  }

  /** contexto de comissão/incentivo global do imóvel */
  private getCommissionContext() {
    const d = this.detailsForm?.data ?? {};
    return {
      isPercentageCommission: !!d.isPercentageCommission,
      saleCommission: Number(d.saleCommission) || 0,
      // incentivos podem não existir — default 0
      isPercentageIncentive: !!d.isPercentageIncentive,
      incentiveStay: Number(d.incentiveStay) || 0,
    };
  }

  onPaymentChange(payment: any) {
    const price = this.getCurrentPrice();

    let totalFixed = 0;
    let totalPercent = 0;

    this.paymentsConditions?.forEach((p) => {
      const value = Number((p.value || "0").toString().replace(/\s/g, ""));
      if (p === payment) return; // ignora o que está editando
      if (p.valueType === "FIXED") totalFixed += value;
      else if (p.valueType === "PERCENTAGE") totalPercent += value;
    });

    const currentValue = Number(
      (payment.value || "0").toString().replace(/\s/g, ""),
    );

    if (price > 0) {
      const used = totalFixed + (totalPercent * price) / 100;

      if (payment.valueType === "FIXED") {
        const maxAllowed = price - used;
        if (currentValue > maxAllowed) {
          const suggestion = maxAllowed;
          if (this.toastService.toasts?.length === 0)
            this.showToast(payment.type, suggestion.toLocaleString(), "€");
        }
      } else if (payment.valueType === "PERCENTAGE") {
        const maxAllowed = ((price - used) / price) * 100;
        if (currentValue > maxAllowed) {
          const suggestion = +maxAllowed.toFixed(2);
          if (this.toastService.toasts?.length === 0)
            this.showToast(payment.type, suggestion, "%");
        }
      }
    } else {
      // sem preço: só valida percentuais
      if (payment.valueType === "PERCENTAGE") {
        let totalPercentOther = 0;
        this.paymentsConditions?.forEach((p) => {
          if (p === payment) return;
          if (p.valueType === "PERCENTAGE")
            totalPercentOther += Number(p.value || 0);
        });
        const maxAllowed = 100 - totalPercentOther;
        if (currentValue > maxAllowed) {
          const suggestion = +maxAllowed.toFixed(2);
          if (this.toastService.toasts?.length === 0)
            this.showToast(payment.type, suggestion, "%");
        }
      }
    }
  }

  showToast(text: any, value: any, type: "%" | "€") {
    const typeStr = this.translateService.instant(
      this.getPaymentConditionText(text),
    );
    const fullText = this.translateService.instant(
      "t-new-sales.t-total-commission-warning",
      {
        value1: typeStr,
        value2: value,
        value3: type,
      },
    );
    this.toastService.show(`⚠️ ${fullText}`, {
      classname: "bg-warning text-white",
      delay: 4000,
    });
  }

  addPaymentCondition() {
    if (this.paymentsConditions)
      this.paymentsConditions.push({
        type: "SIGNAL",
        valueType: "PERCENTAGE",
        value: "0",
        paymentMoment: "",
        agencyValue: "0",
        order: this.paymentsConditions.length + 1,
      });
    else
      this.paymentsConditions = [
        {
          type: "SALE_AGREEMENT",
          valueType: "PERCENTAGE",
          value: "50",
          paymentMoment: "",
          agencyValue: "50",
          order: 1,
        },
      ];
  }

  removePaymentCondition(index: number) {
    this.paymentsConditions?.splice(index, 1);
    this.reorderPayments();
  }

  drop(event: any) {
    moveItemInArray(
      this.paymentsConditions ?? [],
      event.previousIndex,
      event.currentIndex,
    );
    this.reorderPayments();
  }

  reorderPayments() {
    this.paymentsConditions = this.paymentsConditions?.map((p, i) => ({
      ...p,
      order: i + 1,
    }));
  }

  getPaymentConditionText(
    type: "DEED" | "SALE_AGREEMENT" | "RESERVATION" | "SIGNAL",
  ) {
    switch (type) {
      case "DEED":
        return "t-new-sales.t-deed";
      case "SALE_AGREEMENT":
        return "t-new-sales.t-sale-agreement";
      case "RESERVATION":
        return "t-new-sales.t-reservation";
      case "SIGNAL":
        return "t-new-sales.t-signal";
      default:
        return "";
    }
  }

  getPaymentConditionIcon(
    type: "DEED" | "SALE_AGREEMENT" | "RESERVATION" | "SIGNAL",
  ) {
    switch (type) {
      case "DEED":
        return "mdi-file-document-edit-outline";
      case "SALE_AGREEMENT":
        return "mdi-file-sign";
      case "RESERVATION":
        return "mdi-handshake-outline";
      case "SIGNAL":
        return "mdi-cash-fast";
      default:
        return "";
    }
  }

  getPaymentConditionValue(payment: {
    type: "DEED" | "SALE_AGREEMENT" | "RESERVATION" | "SIGNAL";
    valueType: "PERCENTAGE" | "FIXED";
    value: string;
  }) {
    const price = this.getCurrentPrice();

    if (payment.valueType === "PERCENTAGE") {
      if (price) {
        const percentage = Number(payment.value || 0);
        const val = this.formatNumber(price * (percentage / 100));
        return `${this.priceFormat(val)} (${percentage}%)`;
      } else {
        return `${payment.value} %`;
      }
    } else {
      if (price) {
        const fixedValue = Number(payment.value || 0);
        const pct = this.formatNumber((fixedValue / price) * 100);
        return `${this.priceFormat(payment.value)} (${pct} %)`;
      } else {
        return `${this.priceFormat(payment.value)}`;
      }
    }
  }

  getPaymentConditionAgencyValue(payment: {
    type: "DEED" | "SALE_AGREEMENT" | "RESERVATION" | "SIGNAL";
    valueType: "PERCENTAGE" | "FIXED";
    value: string;
    agencyValue?: string; // % da comissão da agência pago nesta fase (sobre a COMISSÃO)
  }) {
    const price = this.getCurrentPrice();
    const {
      isPercentageCommission,
      saleCommission,
      isPercentageIncentive,
      incentiveStay,
    } = this.getCommissionContext();

    if (price > 0) {
      // totais globais
      const commissionTotal = isPercentageCommission
        ? price * (saleCommission / 100)
        : saleCommission;
      const incentiveTotal = isPercentageIncentive
        ? price * (incentiveStay / 100)
        : incentiveStay;

      const agencyPhasePct = Number(payment.agencyValue) || 0;

      const commissionThisPhase = commissionTotal * (agencyPhasePct / 100);
      const incentiveThisPhase = incentiveTotal * (agencyPhasePct / 100);

      const valueStr = this.priceFormat(this.formatNumber(commissionThisPhase));
      const valueIncentive = this.priceFormat(
        this.formatNumber(incentiveThisPhase),
      );
      const pctStr = ` (${this.formatNumber(agencyPhasePct)}%)`;

      // mostra comissão e, se houver, o incentivo também
      if (incentiveThisPhase > 0) {
        return `${valueStr}${pctStr} + ${valueIncentive}${pctStr}`;
      }
      return `${valueStr}${pctStr}`;
    } else {
      const agencyValue = Number(payment.agencyValue) || 0;
      return `${agencyValue}%`;
    }
  }

  formatNumber(value: number): string {
    return value % 1 === 0 ? value.toString() : value.toFixed(2);
  }

  canMakeCounterOffer() {
    return this.permissionsService.checkMasterPermission('MAKE_COUNTEROFFER', this.property?.store?.id)
      || this.permissionsService.checkAgentPermission(this.property?.mainAgent, 'MAKE_COUNTEROFFER')
      || this.permissionsService.checkAgentPermission(this.proposalSelected?.userId, 'MAKE_COUNTEROFFER')
      || (this.loginUser.role?.name === 'STORE OPERATOR' && this.proposalSelected?.userId === this.loginUser.id)
  }


  /////////////////////////////////////////


  addAgent(type: "listing" | "selling") {
    this.selected[type] = null;
    this.openNewAgent[type] = true;
  }

  removeAgent(type: "listing" | "selling", id: any) {
    const agent = this.allAgents?.find((a: any) => a.id === id);
    if (agent) {
      if (type === "listing") {
        agent.isListingAgent = false;
        const find = this.propertyAgentsData.find(
          (ag: any) => ag.id == agent.id,
        );
        if (find) {
          find.isListingAgent = false;
        }
      } else {
        agent.isSellingAgent = false;
        const find = this.propertyAgentsData.find(
          (ag: any) => ag.id == agent.id,
        );
        if (find) {
          find.isSellingAgent = false;
        }
      }

      this.refreshListings();
    }
  }

  onChangeAgent(id: any, type: "listing" | "selling") {
    if (id) {
      const agentData = this.allAgents?.find((a: any) => a.id === id);
      if (type === "listing" && this.isStoreOperatorAgent(agentData)) {
        return;
      }

      if (!this.propertyAgentsData.find((ag: any) => ag.id == id)) {
        this.propertyAgentsData.push(agentData);
      }
      const agent = this.propertyAgentsData?.find((a: any) => a.id === id);
      if (agent) {
        if (type === "listing" && this.isStoreOperatorAgent(agent)) {
          return;
        }
        agent.add = true;
        if (type === "listing") {
          const newCommission = this.getNewCommission("listing");
          agent.isListingAgent = true;
          this.propertyAgentsData = this.propertyAgentsData.map((a: any) => {
            if (a.isListingAgent) {
              return {
                ...a,
                listingCommission:
                  newCommission && Number(newCommission) > 0
                    ? Number(newCommission)
                    : a.listingCommission,
              };
            }
            return a;
          });
          this.openNewAgent[type] = false;
          this.refreshListings();
        } else {
          const newCommission = this.getNewCommission("selling");
          agent.isSellingAgent = true;
          this.propertyAgentsData = this.propertyAgentsData.map((a: any) => {
            if (a.isSellingAgent) {
              return {
                ...a,
                saleCommission:
                  newCommission && Number(newCommission) > 0
                    ? Number(newCommission)
                    : a.saleCommission,
              };
            }
            return a;
          });
          this.openNewAgent[type] = false;
          this.refreshListings();
        }
        this.agentsChange.emit(this.propertyAgentsData);
      }
    }
  }

  getNewCommission(type: "listing" | "selling") {
    if (type === "listing") {
      const agentsListing = this.propertyAgentsData?.filter(
        (a: any) => a.isListingAgent,
      );
      const commission = agentsListing?.reduce(
        (acc: number, agent: any) =>
          acc + (Number(agent.listingCommission) || 0),
        0,
      );
      return Number.isInteger(commission / (agentsListing.length + 1))
        ? commission / (agentsListing.length + 1)
        : (commission / (agentsListing.length + 1)).toFixed(2);
    } else {
      const agentsSelling = this.propertyAgentsData?.filter(
        (a: any) => a.isSellingAgent,
      );
      const commission = agentsSelling?.reduce(
        (acc: number, agent: any) => acc + (Number(agent.saleCommission) || 0),
        0,
      );
      return Number.isInteger(commission / (agentsSelling.length + 1))
        ? commission / (agentsSelling.length + 1)
        : (commission / (agentsSelling.length + 1)).toFixed(2);
    }
  }

  refreshListings() {
    this.agentsExceptListing = this.allAgents?.filter(
      (a: any) =>
        !this.isStoreOperatorAgent(a) &&
        !this.propertyAgentsData
          ?.filter((ag: any) => ag.isListingAgent)
          .find((ag: any) => ag.id == a.id),
    );
    this.agentsExceptSelling = this.allAgents?.filter(
      (a: any) =>
        !this.propertyAgentsData
          ?.filter((ag: any) => ag.isSellingAgent)
          .find((ag: any) => ag.id == a.id),
    );
  }

  // Delegado ao PermissionsService: um STORE OPERATOR deixa de ser excluído
  // quando a entidade liga "diretores de loja também atuam como consultores".
  private isStoreOperatorAgent(agent: any): boolean {
    return !this.permissionsService.canBeListingAgent(agent);
  }

  getSuffix() {
    return '€';
  }

  getAgents(type: "listing" | "selling") {
    if (type === "listing")
      return this.propertyAgentsData?.filter((a: any) => a.isListingAgent);

    return this.propertyAgentsData?.filter((a: any) => a.isSellingAgent);
  }

  getStoreById(id: any) {
    return this.stores?.find((s: any) => s.id === id)?.name || "";
  }

  private normalizeIdentifier(value: any): string {
    if (value === null || value === undefined) {
      return "";
    }
    return `${value}`.trim();
  }

  private isSameAgent(agentA: any, agentB: any): boolean {
    const candidatesA = [
      agentA?.id,
      agentA?.agentId,
      agentA?.userId,
      agentA?.user?.id,
    ].map((value) => this.normalizeIdentifier(value)).filter(Boolean);

    const candidatesB = [
      agentB?.id,
      agentB?.agentId,
      agentB?.userId,
      agentB?.user?.id,
    ].map((value) => this.normalizeIdentifier(value)).filter(Boolean);

    if (!candidatesA.length || !candidatesB.length) {
      return false;
    }

    return candidatesA.some((value) => candidatesB.includes(value));
  }

  private matchesProposalSender(agent: any, proposal: any): boolean {
    const proposalEmail = this.normalizeIdentifier(
      proposal?.user?.email ?? proposal?.userEmail ?? proposal?.consultantEmail,
    ).toLowerCase();

    const agentEmails = [
      agent?.email,
      agent?.user?.email,
    ]
      .map((value) => this.normalizeIdentifier(value).toLowerCase())
      .filter(Boolean);

    if (proposalEmail && agentEmails.includes(proposalEmail)) {
      return true;
    }

    const proposalCandidates = [
      proposal?.userId,
      proposal?.user?.id,
      proposal?.proposalUserId,
      proposal?.consultantId,
    ].map((value) => this.normalizeIdentifier(value)).filter(Boolean);

    const agentCandidates = [
      agent?.id,
      agent?.agentId,
      agent?.userId,
      agent?.user?.id,
    ].map((value) => this.normalizeIdentifier(value)).filter(Boolean);

    if (!proposalCandidates.length || !agentCandidates.length) {
      return false;
    }

    return agentCandidates.some((value) => proposalCandidates.includes(value));
  }

  private applyProposalSenderAsSellingAgent(): void {
    if (!this.proposalSelected) {
      return;
    }

    const allCandidates = [
      ...(this.propertyAgentsData ?? []),
      ...(this.allAgents ?? []),
    ];
    const senderAgent = allCandidates.find((agent: any) =>
      this.matchesProposalSender(agent, this.proposalSelected),
    );

    if (!senderAgent) {
      return;
    }

    if (!this.propertyAgentsData) {
      this.propertyAgentsData = [];
    }

    const existing = this.propertyAgentsData.find((agent: any) =>
      this.isSameAgent(agent, senderAgent),
    );

    if (!existing) {
      this.propertyAgentsData.push({
        ...senderAgent,
        isListingAgent: !!senderAgent?.isListingAgent,
        isSellingAgent: false,
        listingCommission: senderAgent?.listingCommission ?? senderAgent?.listingCom ?? 0,
        saleCommission: senderAgent?.saleCommission ?? senderAgent?.saleCom ?? 0,
      });
    }

    this.propertyAgentsData = this.propertyAgentsData.map((agent: any) => ({
      ...agent,
      isSellingAgent: this.isSameAgent(agent, senderAgent),
    }));
  }

  openCheck(content: any) {
    this.applyProposalSenderAsSellingAgent();

    this.propertyDetailsForm = this.formBuilder.group({
      reference: [this.detailsForm?.data?.reference],
      store: [
        this.detailsForm?.data?.store
          ? this.detailsForm?.data?.store
          : null,
      ],

      businessStatus: [
        this.detailsForm?.data?.businessStatus],
      price: [this.detailsForm?.data?.price],
      saleDate: [this.detailsForm?.data?.saleDate ?? new Date()],
      saleValue: [this.proposalSelected?.history ? this.proposalSelected?.history[0]?.value : this.detailsForm?.data?.saleValue && this.detailsForm?.data?.saleValue > 0 ? this.detailsForm?.data?.saleValue : this.detailsForm?.data?.price],
      saleCommission: [
        this.detailsForm?.data?.saleCommission
          ? this.detailsForm?.data?.saleCommission
          : this.dataToFormInitDetails?.commissions?.saleCommission,
      ],
      isPercentageCommission: [
        this.detailsForm?.data?.isPercentageCommission === undefined
          ? true
          : this.detailsForm?.data?.isPercentageCommission === true,
      ],
      // Proposta de agência (externa) ou de outra loja da rede (interna):
      // o modal de validação abre com a Venda Partilhada pré-preenchida com
      // as condições enviadas na proposta.
      sharedSale: [
        this.proposalSelected?.agencyProposal ||
          this.proposalSelected?.internalShare ||
          this.detailsForm?.data?.sharedSale ||
          false,
      ],
      shareType: [
        this.proposalSelected?.internalShare ? "internal" : "external",
      ],
      partnerStoreId: [this.proposalSelected?.partnerStoreId ?? null],
      internalShareSellerId: [
        this.proposalSelected?.internalShare
          ? this.proposalSelected?.user?.id ??
            this.proposalSelected?.userId ??
            null
          : null,
      ],
      internalShareSellerCommission: [null],
      sharedCommission: [
        (this.proposalSelected?.agencyProposal ||
          this.proposalSelected?.internalShare) &&
          (this.proposalSelected?.lastAction?.saleDivision ??
            this.proposalSelected?.history?.[0]?.saleDivision) != null
          ? 100 -
            Number(
              this.proposalSelected?.lastAction?.saleDivision ??
                this.proposalSelected?.history?.[0]?.saleDivision,
            )
          : this.detailsForm?.data?.sharedCommission
            ? this.detailsForm?.data?.sharedCommission
            : 50,
      ],
      partnerEntityName: [
        this.proposalSelected?.partnerEntityName ??
          this.detailsForm?.data?.partnerEntityName ??
          null,
      ],
      methodPaymentCommission: [
        this.detailsForm?.data?.methodPaymentCommission
          ? this.detailsForm?.data?.methodPaymentCommission
          : 0,
      ],
      splitCommissionValue: [
        this.detailsForm?.data?.splitCommissionValue
          ? this.detailsForm?.data?.splitCommissionValue
          : this.detailsForm?.data?.saleCommission,
      ],
      dealId: [this.detailsForm?.data?.dealId ?? this.property?.dealId ?? null],
      paymentsConditions: [this.paymentsConditions],
      inventoryValue: [this.detailsForm?.data?.inventoryValue]
    });
    this.refreshListings();
    this.modalCheck = this.modalService.open(content, {
      size: "xl",
      centered: true,
      backdropClass: "custom-modal",
      scrollable: true,
    })
  }


  ngOnDestroy(): void {
    clearTimeout(this.proposalsWindowTimer);
    this.subscription.unsubscribe();
  }
}

